export default __webpack_public_path__ + "static/media/b6.a6c00ec8.jpg";